<template id="main">
    <div>
        <Banner></Banner>
        <div class="m-main">
            <Industry></Industry>
            <div class="m-part2">
                <Opinion></Opinion>
                <Cooperation></Cooperation>
                <Judge :judgeArr="judgeDatas"></Judge>
            </div>
        </div>
        <Nav :navArr="NavDatas"></Nav>
        <Foot></Foot>
        <!-- <Login></Login> -->
    </div>
</template>

<script>

import Banner from "@/components/Banner";
import Industry from "@/components/Industry";
import Opinion from "@/components/Opinion";
import Cooperation from "@/components/Cooperation";
import Judge from "@/components/Judge";
import Nav from "@/components/Nav";
import Foot from "@/components/Footer";
// import Login from "@/components/Login";
export default {
    components: {
        // Title, 
        Banner,
        Industry,
        Opinion,
        Cooperation,
        Judge,
        Nav,
        Foot
        // Login
    },
    data() {
        return {
            // judgeTitle: pageDatas.judgeDatas.titleArr,
            judgeDatas: pageDatas.judgeDatas,
            NavDatas: pageDatas.navDatas.datas
        };
    },
    created() {
        this.detection();
    },
    metaInfo() {
        return {
            title: this.pageName
        };
    },
    mounted() {
        // setTimeout(() => {
        //     this.pageName = "async";
        // }, 2000);
        //     });
    },
    methods: {
        detection() {
            let name = sessionStorage.getItem("name");
            // alert(name);
            if (!name) {
                this.$router.push({ path: "/" });
            }
        }
    }
};
</script>
<style lang="scss">
@import "../scss/main.scss";
</style>